import { useState } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect } from "../../../components/hooks";
import { QaAPI } from "../../../axios/api";

import ModuleAccordion from "../../../components/common/accordion";

export default function MemberQa() {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState(null);

  useAbortedEffect((signal) => {
    dispatch(setProgress(true));

    let params = {};

    QaAPI.getQuestionAndAnswerList({
      data: params,
      options: { signal },
    }).then((result) => {
      let { Response, data, total, message } = result;

      if (Response === 1) {
        data = data.map((item) => ({
          title: item.question,
          content: item.answer,
        }));
        setApiData(data);
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  }, []);

  return (
    <>
      {apiData && apiData.length > 0 && <ModuleAccordion data={apiData} />}

      {apiData && apiData.length === 0 && (
        <div className="text-orange-400 text-center text-xl font-bold">
          無資料
        </div>
      )}
    </>
  );
}
